import { useEffect, useMemo, useState } from 'react'
import TollReportTable from '../components/TollTables/TollReportTable'
import { useFilterOnConsolidateAgreement } from '../../hooks/useFilterOnConsolidateAgreement'
import { useQuery } from 'react-query'
import { fetchTollReport } from '../../../../api/api'
import { useChosenCompany } from '../../../../context/UserProvider'
import { Select } from '../../../cars/components/V3/_shared/Select'
import { ConsolidateInvoiceSelect } from '../../../cars/components/V3/_shared/ConsolidateInvoiceSelect'
import { ExcelExportButton } from '../components/ExcelExporter'
import { excelTollReportColumns } from '../components/TollTables/excelUtils'
import type { Toll } from '../../../../types'

const TollReport = () => {
  const company = useChosenCompany()
  const companyId = company?.id

  const [year, yearSet] = useState('')

  const { data: response, status } = useQuery(['tollReport', companyId], () => fetchTollReport(companyId), {
    enabled: !!companyId,
  })

  const data = (Array.isArray(response) ? response : response && 'data' in response ? response.data : []) as Toll[]

  const reportYears = useMemo(() => {
    return Array.from(new Set(data.map((el) => el.tYear)))
  }, [data])

  useEffect(() => {
    if (reportYears.length > 0 && year === '') {
      const newestYear = Math.max(...reportYears.map((y) => Number(y))).toString()
      yearSet(newestYear)
    }
  }, [reportYears, year])

  const items = [
    { value: 'all', label: 'Alle' },
    ...reportYears.map((year) => ({ value: String(year), label: String(year) })),
  ]

  const agreementFilter = useFilterOnConsolidateAgreement()
  const filteredData = data
    .filter((el) => year === 'all' || el.tYear === year)
    .filter(agreementFilter('consolidatedInvoiceAgreement'))
  const columns = excelTollReportColumns()
  const config = { columns, filename: `Bompasseringer_${year}.xlsx`, sheetName: `Bompasseringer_${year}` }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:items-center gap-2 md:justify-between">
        <div className="flex flex-row justify-between items-center">
          <span className="text-xl font-medium text-primaryText">Bompasseringer</span>
          <div className="md:hidden">
            <ExcelExportButton data={filteredData} config={config} />
          </div>
        </div>
        <div className="flex flex-row gap-2 w-full md:w-auto">
          <div className="flex-1 md:flex-none">
            <Select className="h-11 w-full" placeholder={'Periode'} options={items} value={year} onChange={yearSet} />
          </div>
          <div className="flex-1 md:flex-none">
            <ConsolidateInvoiceSelect className="h-11 w-full" />
          </div>
          <div className="hidden md:block">
            <ExcelExportButton data={filteredData} config={config} />
          </div>
        </div>
      </div>

      <TollReportTable isLoading={status === 'loading'} data={filteredData} />
    </div>
  )
}

export default TollReport
